import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useEditGroupsMutation } from "./usersApiSlice"

const ChangeMultiGroupForm = ({ groups }) => {
    const {groupId, type} = useParams()
    const [editGroup, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useEditGroupsMutation()

    const navigate = useNavigate()

    const [filterGroup, setFilterGroup] = useState('')
    const [addGroup, setAddGroup] = useState('')
    const [removeGroup , setRemoveGroup] = useState('')
   
    useEffect(() => {
        if (isSuccess) {
            setFilterGroup('')
            setAddGroup('')
            setRemoveGroup('')
        }
    }, [isSuccess])

   
    const canSave = [addGroup, removeGroup].some(Boolean) && !isLoading

    const onSaveTaskClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
         const {data} =    await editGroup({ filterGroup,addGroup, removeGroup})
         if(data?.id)
            navigate(`/${type}/${groupId}/tasks/${data?.id}`)
        }
    }

    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name} - {group.year} - {group.companyname}</option >
        )
    })

    const errClass = isError ? "errmsg" : "offscreen"

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveTaskClicked}>
                <div className="form__title-row">
                    <h2>Edit Multi Groups</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/users`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                    </div>
                </div>
                <label className="form__label form__checkbox-container" htmlFor="filterGroup">
                        Filter group (apply the add/remove group to all users that related to this group):</label>
                    <select
                        id="filterGroup"
                        name="filterGroup"
                        className={`form__input`}
                        value={filterGroup}
                        onChange={(e)=>setFilterGroup(e.target.value)}
                    >
                        <option></option>
                        {options}
                    </select>

                    <label className="form__label form__checkbox-container" htmlFor="addGroup">
                        ADD GROUP:</label>
                    <select
                        id="addGroup"
                        name="addGroup"
                        className={`form__input  ${!canSave &&'form__input--incomplete'}`}
                        value={addGroup}
                        onChange={(e)=>setAddGroup(e.target.value)}
                    >
                        <option></option>
                        {options}
                    </select>

                    <label className="form__label form__checkbox-container" htmlFor="removeGroup">
                        REMOVE GROUP:</label>
                    <select
                        id="removeGroup"
                        name="removeGroup"
                        className={`form__input  ${!canSave &&'form__input--incomplete'}`}
                        value={removeGroup}
                        onChange={(e)=>setRemoveGroup(e.target.value)}
                    >
                        <option></option>
                        {options}
                    </select>

       
        
       
            

            </form>
        </>
    )

    return content
}


export default ChangeMultiGroupForm